import { DetentionHistoryTable } from "../DetentionHistoryTable";
import { Checkbox, DataSource, Layout, SearchPanel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDetentionHistoryList extends Layout {
    checkboxAuthNumBlank: Checkbox;
    checkboxBillApproved: Checkbox;
    layoutDetentionHistoryTable: DetentionHistoryTable;
    searchpanelDetention: SearchPanel;
    sourceDetentionHistoryLookup: DataSource;
    sourceDetentionProfile: DataSource;
    textboxAuthorizationNumSearch: Textbox;
    textboxAuthorizationStatusSearch: Textbox;
    textboxCarrierSearch: Textbox;
    textboxCreationDateSearch: Textbox;
    textboxCustomerIdSearch: Textbox;
    textboxDefaults: Textbox;
    textboxDetentionChargeStatusSearch: Textbox;
    textboxDetentionPayStatusSearch: Textbox;
    textboxDriverIdSearch: Textbox;
    textboxMovementoperationsUser: Textbox;
    textboxOrderIdSearch: Textbox;
    textboxPayApprovalSearch: Textbox;
    textboxStatusSearch: Textbox;
    textboxStopLocationId: Textbox;
    textboxTractorIdSearch: Textbox;
}
